import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  formControl: {
    minWidth: '90px',
    display: 'inline'
  },
  selectInput: {
    fontSize: '13px',
    color: '#717171',
    '&::before': {
      border: 'none'
    }
  }
});

export default useStyles;
